import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SUPERADMIN_GET_GLOBAL_CATALOG,
  SUPERADMIN_GET_CHAIN_CATALOG,
  EDIT_GLOBAL_CATALOG,
  EDIT_CHAIN_CATALOG,
  GET_ADMIN_MENU_CATEGORY,
  GET_ADMIN_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
  GET_ADMIN_GLOBAL_ALL_MENU_ITEMS,
  GLOBAL_ADD_CATALOG_ACTIVE_DATA,
  GET_ADMIN_ADDED_TEMPLATES_GLOBAL,
  GET_ADMIN_ADDED_TEMPLATES_CHAIN,
} from "../../types";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

import Alert from "react-s-alert";

export const admin_create_global_catalog =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let create_global_catalog = await axios.post(
        `${serverApi}/catalogue `,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (create_global_catalog.status === 201) {
        Alert.success(`<h4>Catalogue added sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
        //   dispatch({
        //     type: UPDATE_ADMIN_OFFER_STATUS,
        //     payload: update_admin_offer_status.data,
        //   });
      }
      onSuccess();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_create_chain_catalog =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let create_global_catalog = await axios.post(
        `${serverApi}/chaincatalogue `,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (create_global_catalog.status === 201) {
        Alert.success(`<h4>Catalogue added sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
        //   dispatch({
        //     type: UPDATE_ADMIN_OFFER_STATUS,
        //     payload: update_admin_offer_status.data,
        //   });
      }
      onSuccess();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_global_catalog = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let get_global_catalog = await axios.get(
      `${serverApi}/catalogue`,

      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_global_catalog.status === 200) {
      dispatch({ type: CLEAR_LOADER });
      dispatch({
        type: SUPERADMIN_GET_GLOBAL_CATALOG,
        payload: get_global_catalog.data,
      });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_get_chain_catalog = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });

  try {
    let get_chain_catalog = await axios.get(
      `${serverApi}/admin/chaincatalogue`,

      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (get_chain_catalog.status === 200) {
      dispatch({ type: CLEAR_LOADER });
      dispatch({
        type: SUPERADMIN_GET_CHAIN_CATALOG,
        payload: get_chain_catalog.data,
      });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_delete_global_catalog =
  (token, catId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let delete_global_catalog = await axios.delete(
        `${serverApi}/catalogue/${catId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (delete_global_catalog.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        Alert.success(`<h4>Catalogue Deleted sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        // dispatch({
        //   type: SUPERADMIN_GET_GLOBAL_CATALOG,
        //   payload: get_global_catalog.data,
        // });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_global_catalog =
  (token, formData, catId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let admin_update_catalog = await axios.patch(
        `${serverApi}/catalogue/${catId}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (admin_update_catalog.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        Alert.success(`<h4>Catalogue updated sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        let formData = { edit: false };
        dispatch({ type: EDIT_GLOBAL_CATALOG, payload: formData });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_delete_chain_catalog =
  (token, catId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let delete_chain_catalog = await axios.delete(
        `${serverApi}/chaincatalogue/${catId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (delete_chain_catalog.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        Alert.success(`<h4>Catalogue Deleted sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        // dispatch({
        //   type: SUPERADMIN_GET_GLOBAL_CATALOG,
        //   payload: get_global_catalog.data,
        // });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_chain_catalog =
  (token, formData, catId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let admin_update_catalog = await axios.patch(
        `${serverApi}/chaincatalogue/${catId}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (admin_update_catalog.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
        Alert.success(`<h4>Catalogue updated sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        let formData = { edit: false };
        dispatch({ type: EDIT_CHAIN_CATALOG, payload: formData });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_category_menu_setup =
  (token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });
    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/admin/menu-category?is_global=true&is_chain_catalogue=false`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_category_menu_setup_date_filter =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/admin/menu-category?is_global=true&is_chain_catalogue=false&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_category_chain_menu_setup =
  (token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });
    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/admin/menu-category?is_chain_catalogue=true&is_global=false`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_category_chain_menu_setup_date_filter =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_category_menu_setup = await axios.get(
        `${serverApi}/admin/menu-category?is_chain_catalogue=true&is_global=false&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_category_menu_setup.status === 200) {
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY,
          payload: get_category_menu_setup.data,
        });
        onSuccess(get_category_menu_setup.data);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_new_item_admin_menu_setup =
  (formData, token, onSuccessMenu) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let add_new_item_admin_menu_setup = await axios.post(
        `${serverApi}/admin/items`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_new_item_admin_menu_setup.status === 201) {
        dispatch({
          type: SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
          payload: add_new_item_admin_menu_setup.data._id,
        });
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY_ITEMS,
          payload: add_new_item_admin_menu_setup.data,
        });
        onSuccessMenu();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_item_admin_menu_setup =
  (itemId, formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let update_new_item_menu_setup = await axios.patch(
        `${serverApi}/admin/items/${itemId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_new_item_menu_setup.status === 200) {
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY_ITEMS,
          payload: update_new_item_menu_setup.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const add_category_admin_menu_setup =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_category_menu_setup = await axios.post(
        `${serverApi}/admin/menu-category`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_category_menu_setup.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Category Added Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const edit_category_admin_menu_setup =
  (categoryId, formData, token, onSuccess, msg) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_category_menu_setup = await axios.patch(
        `${serverApi}/admin/menu-category/${categoryId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (edit_category_menu_setup.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>${msg}</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_category_admin_menu_setup =
  (categoryId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_category_menu_setup = await axios.delete(
        `${serverApi}/admin/menu-category/${categoryId}`,

        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (edit_category_menu_setup.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Category deleted  Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_category_menu_setup_admin =
  (categoryId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_category_menu_setup = await axios.delete(
        `${serverApi}/admin/menu-category/${categoryId}`,

        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (edit_category_menu_setup.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Category deleted  Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_items_menu_setup =
  (token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_menu_items = await axios.get(
        `${serverApi}/admin/items?is_global=true&is_chain_catalogue=false`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_menu_items.status === 200) {
        dispatch({
          type: GET_ADMIN_GLOBAL_ALL_MENU_ITEMS,
          payload: get_menu_items.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_items_menu_setup_date_filter =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_menu_items = await axios.get(
        `${serverApi}/admin/items?is_global=true&is_chain_catalogue=false&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_menu_items.status === 200) {
        dispatch({
          type: GET_ADMIN_GLOBAL_ALL_MENU_ITEMS,
          payload: get_menu_items.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_items_menu_setup_chain =
  (token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_menu_items = await axios.get(
        `${serverApi}/admin/items?is_global=false&is_chain_catalogue=true`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_menu_items.status === 200) {
        dispatch({
          type: GET_ADMIN_GLOBAL_ALL_MENU_ITEMS,
          payload: get_menu_items.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_items_menu_setup_chain_date_filter =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_menu_items = await axios.get(
        `${serverApi}/admin/items?is_global=false&is_chain_catalogue=true&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_menu_items.status === 200) {
        dispatch({
          type: GET_ADMIN_GLOBAL_ALL_MENU_ITEMS,
          payload: get_menu_items.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_item_details_from_item_id =
  (itemId, token) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_item_from_category = await axios.get(
        `${serverApi}/admin/items/${itemId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_item_from_category.status === 200) {
        dispatch({
          type: GET_ADMIN_MENU_CATEGORY_ITEMS,
          payload: get_item_from_category.data,
        });

        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_item_admin_menu_setup =
  (itemId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_item_from_category = await axios.delete(
        `${serverApi}/admin/items/${itemId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_item_from_category.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Item Deleted sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_global_catalog_by_catalog_id =
  (token, id) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_global_catalog_by_id = await axios.get(
        `${serverApi}/catalogue/${id}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_global_catalog_by_id.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GLOBAL_ADD_CATALOG_ACTIVE_DATA,
          payload: get_global_catalog_by_id.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_chain_catalog_by_catalog_id =
  (token, id) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_global_catalog_by_id = await axios.get(
        `${serverApi}/admin/chaincatalogue/${id}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_global_catalog_by_id.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GLOBAL_ADD_CATALOG_ACTIVE_DATA,
          payload: get_global_catalog_by_id.data,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_admin_global_added_templates = (token) => async (dispatch) => {
  //dispatch({ type: CLEAR_ERRORS });
  try {
    let get_added_templates = await axios.get(
      `${serverApi}/admin/templates?is_global=true`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_added_templates.status === 200) {
      dispatch({
        type: GET_ADMIN_ADDED_TEMPLATES_GLOBAL,
        payload: get_added_templates.data,
      });

      //dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_admin_global_added_templates_date_filter =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_added_templates = await axios.get(
        `${serverApi}/admin/templates?is_global=true&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_added_templates.status === 200) {
        dispatch({
          type: GET_ADMIN_ADDED_TEMPLATES_GLOBAL,
          payload: get_added_templates.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_admin_chain_added_templates = (token) => async (dispatch) => {
  //dispatch({ type: CLEAR_ERRORS });
  //dispatch({ type: SET_LOADER });
  try {
    let get_added_templates = await axios.get(
      `${serverApi}/admin/templates?is_global=false&is_chain_catalogue=true`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_added_templates.status === 200) {
      dispatch({
        type: GET_ADMIN_ADDED_TEMPLATES_CHAIN,
        payload: get_added_templates.data,
      });
      //dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_admin_chain_added_templates_date_filter =
  (token, startDate, endDate, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_added_templates = await axios.get(
        `${serverApi}/admin/templates?is_global=false&is_chain_catalogue=true&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_added_templates.status === 200) {
        dispatch({
          type: GET_ADMIN_ADDED_TEMPLATES_CHAIN,
          payload: get_added_templates.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const add_admin_new_template =
  (formData, token, onSuccess, msg, onGetData) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let add_new_template_vendor = await axios.post(
        `${serverApi}/admin/templates`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_new_template_vendor.status === 201) {
        onSuccess(msg);

        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const add_new_choice_template_admin =
  (templateId, formData, token, onSuccess, msg) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let add_new_choice_template_vendor = await axios.patch(
        `${serverApi}/admin/templates/${templateId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_new_choice_template_vendor.status === 200) {
        onSuccess(msg);

        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_admin_template =
  (templateId, token, onSuccess) => async (dispatch) => {
    //dispatch({ type: CLEAR_ERRORS });
    //dispatch({ type: SET_LOADER });

    try {
      let deleteVendorTemplate = await axios.delete(
        `${serverApi}/admin/templates/${templateId}`,

        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (deleteVendorTemplate.status === 200) {
        onSuccess();

        // dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
